import React, { useEffect, useState } from "react";
import axios from "axios";
import CurrentUserStore from "../../stores/CurrentUserStore";
import SalaryCompensationSection from "./SalaryCompensationSection";
import SalaryGoalsCalculationSection from "./SalaryGoalsCalculationSection";
import Flexbox from "flexbox-react";
import  ToastStore  from "../../stores/ToastStore";
import Cookies from "js-cookie";
import "./UserProfileSalary.css";
const UserProfileSalaryBonus = ({
    employeeId
}) => {
    const [loading, setLoading] = useState(false);
    const [compensation, setCompensation] = useState({
        id: null,
        base_salary: "",
        annual_bonus_percentage: "",
        annual_bonus_amount: "",
        quarterly_bonus_amount: ""
    });
    const [goalCycles, setGoalCycles] = useState([]);
    const [selectedGoalCycle, setSelectedGoalCycle] = useState(null);
    const [goals, setGoals] = useState([]);
    const [calculation, setCalculation] = useState({
        total_salary: "",
        total_bonus_amount: "",
    });

    const isAdmin = CurrentUserStore.userIsAccountOwner;

    useEffect(() => {
        loadInitialData();
    }, [employeeId]);

    useEffect(() => {
        if (!selectedGoalCycle) return;
        fetchGoals(selectedGoalCycle.id);
    }, [selectedGoalCycle]);

    const loadInitialData = async () => {
        setLoading(true);
        await Promise.all([
            fetchCompensation(),
            fetchGoalCycles()
        ]);
        setLoading(false);
    };

    const fetchCompensation = async () => {
        try {
            const response = await axios.get(
                `${Cookies.get("apiEnv")}/employee_compensation/${employeeId}`
            );
            if (response.data) {
                setCompensation(response.data);
            }
        } catch (error) {
            console.error(error);
        }
    };

    const saveCompensation = async () => {
    
        try {
            
            if (compensation.annual_bonus_percentage < 0 || compensation.annual_bonus_percentage > 100) {
                ToastStore.showToast("Annual bonus percentage must be between 0 and 100", "danger");
                return;
            }
            if(!compensation.base_salary) {
                ToastStore.showToast("Base salary is required", "danger");
                return;
            }
            if(compensation.annual_bonus_amount < 0) {
                ToastStore.showToast("Annual bonus amount must be greater than 0", "danger");
                return;
            }
            setLoading(true);
            const payload = {
                user_id: employeeId,
                base_salary: compensation.base_salary,
                annual_bonus_percentage: compensation.annual_bonus_percentage
            };

            if (compensation.id) {
                await axios.put(
                    `${Cookies.get("apiEnv")}/employee_compensation/${compensation.id}`,
                    payload
                );
            } else {
                await axios.post(`${Cookies.get("apiEnv")}/employee_compensation`,
                    payload
                );
            }
            setLoading(false);
            ToastStore.showToast("Compensation saved successfully", "success");
            await fetchCompensation();
            fetchGoals(selectedGoalCycle.id);

        } catch (error) {
            console.error(error);
            ToastStore.showToast("Failed to save compensation", "danger");
            setLoading(false);
        }
    };

    const fetchGoalCycles = () => {
        return axios.get(`${Cookies.get("apiEnv")}/goal_settings/goal_cycle_list`)
            .then(response => {
                setGoalCycles(response.data || []);
                if (response.data.length > 0) {
                    setSelectedGoalCycle(response.data[0]);

                }
            })
            .catch(error => {
                console.error(error);
            });
    };

    const fetchGoals = async goalCycleId => {
        try {
            const response = await axios.get(
                `${Cookies.get("apiEnv")}/employee_compensation/${employeeId}/goals?goal_setting_id=${goalCycleId}`
            );

            setGoals(response.data.goals || []);
            setCalculation({
                total_salary: response.data.total_salary,
                total_bonus_amount: response.data.total_bonus_amount,
            });
        } catch (error) {
            console.error(error);
        }
    }

    return (
        <>
        {loading ? (
             <div>
             <Flexbox flexGrow={1} flexDirection="column" justifyContent="center" alignItems="center" style={{ marginTop: "230px" }}>
               <img
                 style={{ height: "35px", width: "35px" }}
                 src="https://s01.live2support.com/dashboardv2/chatassets/img/loader_new.gif"
                 alt="Please wait"
               />
             </Flexbox>
           </div>
        ) : (
        <div className="compensation-bonus-page">

            <SalaryCompensationSection
                compensation={compensation}
                setCompensation={setCompensation}
                isAdmin={isAdmin}
                onSave={saveCompensation}
            />

            <SalaryGoalsCalculationSection
                goalCycles={goalCycles}
                selectedGoalCycle={selectedGoalCycle}
                setSelectedGoalCycle={setSelectedGoalCycle}
                goals={goals}
                calculation={calculation}
            />

            </div>
        )
    }
    </>
    );
};

export default UserProfileSalaryBonus;